var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitLab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27917 8.56187H7.56972L4.88079 0.346676C4.82023 0.151921 4.63966 0.0117188 4.42472 0.0117188C4.20978 0.0117188 4.02866 0.151921 3.96811 0.346676L1.27917 8.56187Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4297 8.5496H22.7197L20.0318 0.335503C19.9718 0.141293 19.7896 0 19.5763 0C19.3603 0 19.1781 0.141293 19.1181 0.335503L16.4297 8.5496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5697 8.54883H16.4297L12 22.1844L7.5697 8.54883Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27917 8.54883L12 22.1844L7.56972 8.54883H1.27917Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28025 8.54883L12 22.1855L0.467954 13.8329C0.467954 13.8329 -0.255969 13.4384 0.0969912 12.3425L1.28025 8.54883Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7197 8.54883L12 22.1844L16.4297 8.54883H22.7197Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7197 8.54883L12 22.1844L23.5315 13.8329C23.5315 13.8329 24.2554 13.4384 23.9035 12.3425L22.7197 8.54883Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitLab);
export default __webpack_public_path__ + "static/media/GitLab.f4f2d51893000db2d019fb88d8bf140c.svg";
export { ForwardRef as ReactComponent };